import React, { useEffect, useState } from "react";
import "../../assets/styles/common.css";
import logo from "../../assets/images/Povital - Logo.png";
import { IoMdNotificationsOutline } from "react-icons/io";
import { FaChevronDown } from "react-icons/fa6";
import styles from "./CommonStyle.module.css";
import { IoIosMailOpen } from "react-icons/io";

import {
  Grid,
  Typography,
  Box,
  Menu,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { customTextColor } from "../../utils/const";
import { PiIdentificationCardLight, PiUserCircleLight } from "react-icons/pi";
import { CiLock } from "react-icons/ci";
import { CreditCard } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FaUserTie } from "react-icons/fa6";
import { useTheme } from "@mui/material/styles";
import { resetPassword, signOut } from "../../redux/auth/authSlice";
import { PiUserSwitchFill } from "react-icons/pi";
import { RiLock2Fill } from "react-icons/ri";
import { PiUserCircleGearFill } from "react-icons/pi";
import { PiUserCircleFill } from "react-icons/pi";

const Navbar = () => {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [openLogout, setOpenLogout] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const isMenuOpen = Boolean(menuAnchorEl);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authStatus = useSelector((state) => state.auth.status);
  const authData = useSelector((state) => state.auth.user);
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
    }),
  });

  const profile = useSelector((state) => state.profile.data);

  const handleMenuOpen = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const handleOnClickSubmitForgotPassword = () => {
    if (
      Object.keys(formik.errors).length === 0 &&
      Object.keys(formik.touched).length !== 0
    ) {
      dispatch(resetPassword(formik.values));
    }
    // Swal.fire({
    //     title: "Good job!",
    //     text: "You clicked the button!",
    //     icon: "success"
    // });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickOpenLogOut = () => {
    setOpenLogout(true);
  };

  const handleCloseLogOut = () => {
    setOpenLogout(false);
  };

  const handleOnClickLogOut = () => {
    let userData = { refresh_token: authData?.refresh_token };
    dispatch(signOut(userData));
  };

  useEffect(() => {
    if (authStatus === "signout_succesful") {
      navigate("/");
    }
  }, [authStatus]);

  return (
    <div className="navbar">
      <div className="navbar-logo">
        <img src={logo} alt="Logo" width="150px" />
      </div>
      <div className="user-controls">
        <div className="notification-icon">
          <IoMdNotificationsOutline
            style={{
              color: "#3f475a",
              fontSize: "32px",
              marginRight: "3px",
              marginBottom: "7px",
            }}
          />{" "}
          <h5 style={{ fontSize: "16px" }}>Notification</h5>
        </div>
        <div className="account-icon">
          <img src={profile?.profile?.profile_picture} alt="profile" />{" "}
          <h5 style={{ fontSize: "16px" }}>
            {profile?.profile?.full_name?.split(" ")[0]}
            <FaChevronDown
              onClick={isMenuOpen ? handleMenuClose : handleMenuOpen}
              style={{
                color: "#3f475a",
                fontSize: "15px",
                marginLeft: "5px",
                cursor: "pointer",
              }}
            />
          </h5>
          {/* User Menu */}
          <Menu
            anchorEl={menuAnchorEl}
            open={isMenuOpen}
            onClose={handleMenuClose}
            PaperProps={{
              sx: { padding: "10px", minWidth: "200px" },
            }}
          >
            <Box className={styles.side_details}>
              <Grid container sx={{ color: customTextColor }}>
                <Grid item xs={12}>
                  {/* <MenuItem onClick={handleMenuClose}>
                  <Box display="flex" alignItems="center">
                    <PiIdentificationCardLight
                      style={{ fontSize: "25px", color: customTextColor }}
                    />
                    <Typography sx={{ marginLeft: "10px" }}>
                      <b>Rajesh Kumar Mishra</b>
                    </Typography>
                  </Box>
                </MenuItem> */}

                  <Box className={styles.contain_details}>
                    <PiUserCircleFill
                      style={{ fontSize: "25px", color: customTextColor }}
                    />
                    <Typography sx={{ marginLeft: "10px", cursor: "pointer" }}>
                      <b>{profile?.profile?.full_name}</b>
                    </Typography>
                  </Box>

                  <Box className={styles.contain_details}>
                    <PiUserCircleGearFill
                      style={{ fontSize: "25px", color: customTextColor }}
                    />
                    <Typography
                      sx={{ marginLeft: "10px", cursor: "pointer" }}
                      onClick={() =>
                        navigate("/profile-save", {
                          state: { userDetails: profile?.profile },
                        })
                      }
                    >
                      <b>Update Profile</b>
                    </Typography>
                  </Box>

                  <Box className={styles.contain_details}>
                    <RiLock2Fill
                      style={{ fontSize: "25px", color: customTextColor }}
                    />
                    <Typography
                      sx={{ marginLeft: "10px", cursor: "pointer" }}
                      onClick={handleClickOpen}
                    >
                      <b>Change Password</b>
                    </Typography>
                  </Box>

                  <Box className={styles.contain_details}>
                    <PiUserSwitchFill
                      style={{ fontSize: "25px", color: customTextColor }}
                    />
                    <Typography sx={{ marginLeft: "10px", cursor: "pointer" }}>
                      <b>Switch to Bench Sales</b>
                    </Typography>
                  </Box>
                  {/* <Box className={styles.upload_resume_section}>
                    <Box style={{ color: customTextColor }}>
                      <Typography>
                        <b>Available Credit</b>{" "}
                      </Typography>
                      <Typography sx={{ fontSize: "25px !important" }}>
                        <b>2700</b>
                      </Typography>
                      <Typography>
                        Last transaction was on 20 Dec 2024
                      </Typography>
                    </Box>
                    <Box className={styles.icon_style}>
                      <CreditCard style={{ fontSize: "40px" }} />
                    </Box>
                  </Box> */}
                </Grid>
              </Grid>
            </Box>
            {/* <Box className={styles.forgot_password_btns}>
              <button type="button" onClick={handleMenuClose}>
                Log out
              </button>
            </Box> */}
            <Box className={styles.internal_update_btns}>
              <Box className={styles.add_back_btns}>
                <button
                  style={{
                    backgroundColor: "#1991e0",
                    marginRight: "10px",
                    padding: "5px 10px ",
                  }}
                  onClick={handleClickOpenLogOut}
                >
                  Logout
                </button>
              </Box>
              {/* <Box>
                <button style={{ backgroundColor: "#3856a6 " }}>
                  Add Credit
                </button>
              </Box> */}
            </Box>
          </Menu>
        </div>
      </div>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        maxWidth="lg"
        // fullWidth
        sx={{ "& .MuiDialog-paper": { width: "40%", maxHeight: "90vh" } }}
      >
        <DialogTitle
          id="responsive-dialog-title"
          sx={{ color: "#3856a6", marginTop: "10px" }}
        >
          {"Forgot Password!"}
        </DialogTitle>
        <DialogContent>
          {/* <Grid container>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                sx={{ padding: "0 10px" }}
                // className="login-form"
              >
                <div
                  className="signup_form_group"
                  style={{ marginBottom: "0", padding: "0 10px" }}
                >
                  <span className="field_icon">
                    <FaUserTie />
                    <TextField
                      type="text"
                      name="email"
                      placeholder="Email"
                      sx={{
                        width: "100%",
                        paddingLeft:'30px',
                        backgroundColor: "#fff",
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            border: "none !important",
                          },
                        },
                      }}
                    />
                  </span>
                </div>
              </Grid>
            </Grid> */}
        </DialogContent>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={{ padding: "0 10px" }}>
            <form onSubmit={formik.handleSubmit}>
              <div className="signup_form_group" style={{ padding: "0 10px" }}>
                <span className="field_icon">
                  <IoIosMailOpen />
                  <TextField
                    type="text"
                    name="email"
                    placeholder="Email"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.email}
                    sx={{ width: "100%", backgroundColor: "#fff" }}
                  />
                </span>

                {formik.touched.email && formik.errors.email ? (
                  <div className="login_error">{formik.errors.email}</div>
                ) : null}
              </div>
            </form>
          </Grid>
        </Grid>
        <DialogActions className="forgot_password_modal_btns">
          <button type="submit" onClick={handleOnClickSubmitForgotPassword}>
            Submit
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        fullScreen={fullScreen}
        open={openLogout}
        onClose={handleCloseLogOut}
        aria-labelledby="responsive-dialog-title"
        maxWidth="lg"
        // fullWidth
        sx={{ "& .MuiDialog-paper": { width: "40%", maxHeight: "90vh" } }}
      >
        <DialogTitle
          id="responsive-dialog-title"
          sx={{ color: "#3856a6", marginTop: "10px" }}
        >
          {"Logout!"}
        </DialogTitle>
        <DialogContent>Are you sure you want to logout?</DialogContent>

        <DialogActions className="forgot_password_modal_btns">
          <button type="submit" onClick={handleOnClickLogOut}>
            Yes
          </button>
          <button type="submit" onClick={handleCloseLogOut}>
            No
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Navbar;
